export const PHONE_REGEX = /^\+\d{1,3}\s?\(?\d{2,4}\)?[\s-]?\d{2,4}[\s-]?\d{2,4}[\s-]?\d{0,4}$/;
